"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusDecoder = exports.refreshedTokenDecoder = exports.idTokenDecoder = void 0;
var t = __importStar(require("io-ts"));
var Reason = __importStar(require("./Reason"));
exports.idTokenDecoder = t.intersection([
    t.interface({
        sub: t.string,
        iat: t.number,
        email: t.string,
        nonce: t.string,
    }),
    t.partial({
        given_name: t.string,
        family_name: t.string,
    }),
]);
var jwtDataDecoder = t.intersection([
    t.interface({
        sub: t.string,
        iat: t.number,
        email: t.string,
        nonce: t.string,
    }),
    t.partial({
        given_name: t.string,
        family_name: t.string,
    }),
]);
var authStateDataDecoder = t.intersection([
    t.interface({
        sub: t.string,
        exp: t.number,
        email: t.string,
    }),
    t.partial({
        given_name: t.string,
        family_name: t.string,
    }),
]);
exports.refreshedTokenDecoder = t.interface({
    iat: t.number,
    exp: t.number,
});
var loggedOutReasonDecoder = t.union([
    Reason.authStateParseDecoder,
    Reason.loginParamsValidationDecoder,
    Reason.logoutParamsValidationDecoder,
    Reason.tokenValidatorDecoder,
    Reason.tokensFetcherDecoder,
    Reason.tokenRefresherDecoder,
    Reason.pipResponseValidatorDecoder,
    Reason.explicitDecoder,
]);
var loggedOutDecoder = t.exact(t.interface({
    kind: t.literal("LoggedOut"),
    reason: loggedOutReasonDecoder,
    feedback: t.boolean,
}));
var loggedInDecoder = t.exact(t.interface({
    kind: t.literal("LoggedIn"),
    data: authStateDataDecoder,
}));
exports.statusDecoder = t.union([loggedInDecoder, loggedOutDecoder]);
